import interceptors from "./interceptors/index";

const saveCatalog = (data) => {
  return interceptors({
    url: "/documents/catalogue",
    method: "POST",
    data,
  });
};

const fetchCatalogs = () => {
  return interceptors({
    url: "/documents/catalogue",
    method: "GET",
  });
};

export { saveCatalog, fetchCatalogs };
